export default __webpack_public_path__ + "static/media/xx99-mark-i-on-table.c7e98af3.png";